<template>
  <div class="text-center">
    <div class="">
      <h1>Choose section</h1>
      <div id="nav" class="flex flex-wrap">
        <router-link
          class="sweep-to-bottom text-center animated delay-1"
          :class="{ bounceOutCustom: leave, bounceInCustom: !leave }"
          to="/about"
          ><span>Explore Clariant</span></router-link
        >
        <router-link
          class="sweep-to-bottom text-center animated delay-4"
          :class="{ bounceOutCustom: leave, bounceInCustom: !leave }"
          to="/shared-service-center"
          ><span>Shared Service Center Łódź</span></router-link
        >
        <router-link
          class="sweep-to-bottom text-center animated delay-3"
          :class="{ bounceOutCustom: leave, bounceInCustom: !leave }"
          to="/real-people"
          ><span>#RealPeople OfClariant</span></router-link
        >
        <router-link
          class="sweep-to-bottom text-center animated delay-2"
          :class="{ bounceOutCustom: leave, bounceInCustom: !leave }"
          to="/monopolis"
          ><span>Explore Monopolis</span></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      leave: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.leave = !this.leave;
    setTimeout(next, 550);
  }
};
</script>
